<template>
    <div id="FormBimbingan">
        <div class="r-header">
            Tambah Bimbingan Baru
        </div>
        <div class="r-body">
            <div class="r-alert r-center-flex">
                <img :src="require('@/assets/icons/others/circle-attention.svg')" alt="">
                Pastikan Data bimbingan yang dimasukan benar
            </div>
            <div class="r-guidance-area">
                <div class="r-guidance-header r-center-flex">
                    <span style="font-size: 16px">Data Bimbingan</span>
                    <div class="r-center-flex is-dropdown-mobileview">
                        <p style="margin-right: 10px;">Jenis Bimbingan</p>
                        <div class="y-inputField" style="width: 153px;">
                            <div class="y-hasIcon-right y-sm-size">
                                <div class="r-dropdown r-dropdown-inputStyle r-center-flex" @click.prevent="typeDropdown = !typeDropdown">
                                    <p style="margin-right: auto;padding-right: 10px;">{{item.type}}</p>
                                    <img :src="require('@/assets/icons/others/dropdown-arrow.svg')" alt="">
                                    <div class="r-dropdown-items" style="margin-top: -10px;" :style=" typeDropdown? '' : 'display: none'">
                                        <div class="r-dropdown-item r-center-flex" style="min-width: 150px;" @click.prevent="item.type = 'online' ">Online</div>
                                        <div class="r-dropdown-item r-center-flex" style="min-width: 150px;" @click.prevent="item.type = 'offline' ">Offline</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="r-guidance-body">
                    <div class="r-guidance-tiptap">
                        <div class="r-header-tiptap r-center-flex">
                            Masalah Bimbingan
                        </div>
                        <div class="r-attributes-tiptap r-center-flex">
                            <editor-menu-bar :editor="editor"
                                v-slot="{ commands, isActive }"
                            >
                                <div class="tiptap r-center-flex">
                                    <button class="tiptap_button"
                                        :class="{ 'is-active' : isActive.bold() }"
                                        @click="commands.bold"
                                    >
                                        <img :src="require('@/assets/icons/tiptap/bold.svg')">
                                    </button>

                                    <button class="tiptap_button"
                                        :class="{ 'is-active' : isActive.italic() }"
                                        @click="commands.italic"
                                    >
                                        <img :src="require('@/assets/icons/tiptap/italic.svg')">
                                    </button>

                                    <button class="tiptap_button"
                                        :class="{ 'is-active' : isActive.strike() }"
                                        @click="commands.strike"
                                    >
                                        <strike>S</strike>
                                    </button>

                                    <button class="tiptap_button"
                                        :class="{ 'is-active' : isActive.underline() }"
                                        @click="commands.strike"
                                    >
                                        <u>U</u>
                                    </button>

                                    <button class="tiptap_button"
                                        :class="{ 'is-active' : isActive.ordered_list() }"
                                        @click="commands.ordered_list"
                                    >
                                        <img :src="require('@/assets/icons/tiptap/list.svg')">
                                    </button>

                                    <button class="tiptap_button"
                                        :class="{ 'is-active' : isActive.blockquote() }"
                                        @click="commands.blockquote"
                                    >
                                        <img :src="require('@/assets/icons/tiptap/list.svg')">
                                    </button>

                                    <button class="tiptap_button"
                                        @click="commands.undo"
                                    >
                                        <img :src="require('@/assets/icons/tiptap/undo.svg')">
                                    </button>

                                    <button class="tiptap_button"
                                        @click="commands.redo"
                                    >
                                        <img :src="require('@/assets/icons/tiptap/redo.svg')">
                                    </button>
                                </div>
                            </editor-menu-bar>
                        </div>
                        <div class="r-input-titap y-inputField r-isRelative">
                            <editor-menu-bubble
                                class="menububble" 
                                :editor="editor" 
                                @hide="hideLinkMenu" 
                                v-slot="{ commands, isActive, getMarkAttrs, menu }"
                            >
                                <div
                                    class="menububble"
                                    :class="{ 'is-active': menu.isActive }"
                                    :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
                                >
                                    <form class="menububble__form" v-if="linkMenuIsActive" @submit.prevent="setLinkUrl(commands.link, linkUrl)">
                                        <input class="menububble__input" type="text" v-model="linkUrl" placeholder="https://" ref="linkInput" @keydown.esc="hideLinkMenu"/>
                                        <button class="menububble__button" @click="setLinkUrl(commands.link, null)" type="button">
                                            <img :src="require('@/assets/icons/others/close-outline-white.svg')" alt="">
                                        </button>
                                    </form>

                                    <template v-else>
                                        <button
                                            class="menububble__button"
                                            @click="showLinkMenu(getMarkAttrs('link'))"
                                            :class="{ 'is-active': isActive.link() }"
                                        >
                                            <span>{{ isActive.link() ? 'Update Link' : 'Add Link'}}</span>
                                        </button>
                                    </template>
                                </div>
                            </editor-menu-bubble>
                            <editor-content class="editor__content" :editor="editor" @click.prevent="dropdown = false"/>
                            <div class="y-errorText y-red-text" :style="errorData ? 'opacity: 1 !important;': ''">
                                {{errorMsg}}
                            </div>
                        </div>
                        <div class="r-guidance-button r-center-flex">
                            <ButtonCustom class="y-warning-bg y-hasspace-btn y-white-text y-sm-size is-fullonmobile" 
                                @click.prevent="modal = true" 
                                style="margin-right: auto" 
                            >
                                Preview
                            </ButtonCustom>
                            <ButtonCustom class="y-secondary-btn y-sm-size y-hasspace-btn is-fullonmobile" 
                                @click.prevent="backToGuidance()"
                            >
                                Batal
                            </ButtonCustom>
                            <ButtonCustom class="y-primary-btn y-hasspace-btn y-sm-size is-fullonmobile" 
                                :disabled="loading" @click.prevent="storeData()"
                            >
                                    <span v-if="!loading">Publish</span>
                                    <img :src="require('@/assets/loadingDot.svg')" alt style="width: 50px;" v-else />   
                            </ButtonCustom>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="r-modal" v-if="modal">
            <div class="r-box"> 
                <div class="r-header">
                    <h1>Preview Bimbingan</h1>
                </div>
                <div class="r-body">
                    <h2>Masalah Bimbingan</h2>
                    <div class="r-modal-content" v-html="editor.getHTML()"></div>
                </div>
                <div class="r-footer r-center-flex">
                    <button class="y-primary-btn y-hasspace-btn y-sm-size" style="margin-left: auto" @click.prevent="modal = false">
                        Finish Preview
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
    Blockquote,
    HardBreak,
    Heading,
    HorizontalRule,
    OrderedList,
    BulletList,
    ListItem,
    TodoItem,
    TodoList,
    Bold,
    Italic,
    Link,
    Strike,
    Underline,
    History,
    Image,
    Placeholder
} from 'tiptap-extensions'
import tableMethods from '@/mixins/tableMethods'
import common from '@/mixins/function/common'
import link from '@/mixins/link'
import { mapActions, mapGetters } from "vuex";
export default {
    mixins: [tableMethods, common, link],
    components: {
        EditorContent,
        EditorMenuBar,
    },
    mounted() {
        this.setActiveTab("Tapi")
        const breadcrumb = [
            {
                name: 'Bimbingan Tapi',
                link: {name: 'ListUserBimbingan', query: {...this.$route.query}},
                current: false
            },
            {
                name: 'List Bimbingan',
                link: {name: 'ListBimbingan', params: {tapi_lecture_id: this.$route.params.tapi_lecture_id}, query: {...this.$route.query}},
                current: false
            },
            {
                name: 'Form Bimbingan',
                link: {name: null},
                current: true
            }
        ]
        this.setBreadCrumb(breadcrumb)
        this.item.type = 'online'
    },
    data: () => ({
        editor: new Editor({
            extensions: [
            new Image(),
            new History(),
            new Blockquote(),
            new BulletList(),
            new HardBreak(),
            new Heading({ levels: [1, 2, 3] }),
            new HorizontalRule(),
            new ListItem(),
            new OrderedList(),
            new TodoItem(),
            new TodoList(),
            new Link(),
            new Bold(),
            new Italic(),
            new Strike(),
            new Underline(),
            new Placeholder({
                emptyEditorClass: 'is-editor-empty',
                emptyNodeClass: 'is-empty',
                emptyNodeText: 'Ceritakan Masalah Anda Disini . . .',
                showOnlyWhenEditable: true,
                showOnlyCurrent: true,
            }),
            ],
        }),
        errorData: false,
        errorMsg: 'Tidak boleh kosong',
        loading: false,
        modal:false,
        dropdown: false,
        typeDropdown: false,
        
    }),
    beforeDestroy() {
        this.editor.destroy()
    },
    computed: {
        ...mapGetters ({
            user: 'auth/getUser',
            item: 'tapiGuidance/getItem',
        }),
    },
    methods: {
        ...mapActions ({
            getGuidances: 'tapiGuidance/guidanceData',
            store: 'tapiGuidance/store',
        }),
        backToGuidance(){
            this.$router.push({name: 'ListBimbingan', params: {tapi_lecture_id: this.$route.params.tapi_lecture_id}, query: {...this.$route.query}})
        },
        validateContent(){
            let error = 0;
            let content = this.editor.getHTML()
            if(content === null || content === '' || content === '<p></p>'){
                this.errorData = true
                this.errorMsg = `Field Konten tidak boleh kosong`
                error += 1
            }else{
                this.item.message = content
                this.errorData = false
            }
            return error
        },
        async storeData() {
            if (this.validateContent() === 0) {
                this.loading = true
                const tapi_lecture_id = this.$route.params.tapi_lecture_id
                const tG_id = await this.store({data: this.item, tapi_lecture_id})
                const response = this.getResponse('tapiGuidance')
                if (response.status === 1) {
                    this.showSnackbar ({
                        type: "success",
                        text: response.msg
                    })
                    this.$router.push({name : 'ResponseBimbinganTapi', params: {tapi_lecture_id, tG_id}})
                } else {
                    this.loading = false
                    this.showSnackbar ({
                        type: "error",
                        text: response.msg
                    })
                }
            } else {
                this.showSnackbar ({
                    type: "error",
                    text: "Data Tidak Boleh Kosong"
                })
            }
            this.loading = false
        }
    }
}
</script>
<style lang="scss">
#FormBimbingan{
    background: #FCFCFC;
    border: 1px solid #E6E6E6;
    border-radius: 6px;
    .r-header{
        background: white;
        padding: 20px;
        line-height: 24px;
        color: #333333;
        border-bottom: 1px solid #E6E6E6;
        border-radius: 6px 6px 0px 0px;
    }
    .r-body{
        .r-alert{
            background: #FFF5DC;
            border: 1px solid #FEE3A1;
            box-sizing: border-box;
            border-radius: 4px;
            color: #E1A000;
        }
        .r-guidance-area{
            background: #FFFFFF;
            border: 0.5px solid #DEDEDE;
            box-sizing: border-box;
            box-shadow: 2px 2px 7px rgba(188, 188, 188, 0.03);
            border-radius: 4px;
            .r-guidance-header{
                font-style: normal;
                font-weight: bold;
                line-height: 19px;
                color: #333333;
                border-bottom: 0.5px solid #DEDEDE;
                span{
                    margin-right: auto;
                }
            }
        }
    }
}
</style>
